<template>
  <div class="explore-speeds">
    <h3 class="mb-4">لماذا تختار خدماتنا في أمريكا وكندا؟</h3>

    <Swiper
      :slides-per-view="1"
      :space-between="24"
      :centeredSlides="false"
      :preventClicks="true"
      :loop="true"
      :breakpoints="{
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        992: { slidesPerView: 3 },
        1440: { slidesPerView: 4 },
        1600: { slidesPerView: 5 },
      }"
      :modules="modules"
      class="explore-speeds-slide"
    >
      <SwiperSlide v-for="(feature, index) in featuresList" :key="index">
        <div class="explore-speeds-wrap">
          <div class="explore-mbps">
            <img src="@/assets/images/line.svg" alt="line" />
            <!-- الأيقونة أو الرقم المميز -->
            <h2>{{ feature.title }}</h2>
          </div>
          <div class="starting" style="padding-top: 15px;">
            <!-- النص الوصفي للميزة -->
            <h6 style="font-size: 14px; line-height: 1.5;">{{ feature.desc }}</h6>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay } from "swiper/modules";

export default defineComponent({
  name: "ExploreSpeeds",
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    // التركيز هنا على نقاط القوة (القيمة المضافة) بدلاً من الأسعار
    const featuresList = ref([
      { title: "4K", desc: "أعلى جودة عرض متاحة للبث المباشر" },
      { title: "99.9%", desc: "نسبة استقرار عالية جداً للسيرفرات" },
      { title: "24/7", desc: "دعم فني متواصل لجميع العملاء" },
      { title: "Global", desc: "آلاف القنوات من جميع أنحاء العالم" },
      { title: "Fast", desc: "تفعيل فوري للاشتراك بعد الدفع" },
      { title: "4K", desc: "أعلى جودة عرض متاحة للبث المباشر" },
      { title: "99.9%", desc: "نسبة استقرار عالية جداً للسيرفرات" },
      { title: "24/7", desc: "دعم فني متواصل لجميع العملاء" },
      { title: "Global", desc: "آلاف القنوات من جميع أنحاء العالم" },
      { title: "Fast", desc: "تفعيل فوري للاشتراك بعد الدفع" },
    ]);

    return {
      modules: [Autoplay],
      featuresList,
    };
  },
});
</script>